import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import { Home } from "./pages/home";
import { SalesSolution } from "./pages/SolutionsPages/salesSolution";
import { FleetSolution } from "./pages/SolutionsPages/fleetSolution";
import { SmartApp } from "./pages/SolutionsPages/SmartApp";
import { OemMarketResearch } from "./pages/SolutionsPages/OemMarketReserch";
import { InsureAnalysis } from "./pages/SolutionsPages/InsureAnalysis";
import { DatahubSolution } from "./pages/SolutionsPages/DatahubSolution";
import { ApiFeedSolution } from "./pages/SolutionsPages/apiSolution";
import { CatalogSolution } from "./pages/SolutionsPages/CatalogSolution";
import "./App.css";

const App = () => {
  let routes = useRoutes([
    { path: "/", element: <Home /> },
    { path: "/SalesSolution", element: <SalesSolution /> },
    { path: "/FleetSolution", element: <FleetSolution /> },
    { path: "/SmartApp", element: <SmartApp /> },
    { path: "/OemMarketResearch", element: <OemMarketResearch /> },
    { path: "/InsureAnalysis", element: <InsureAnalysis /> },
    { path: "/DatahubSolution", element: <DatahubSolution /> },
    { path: "/ApiFeedSolution", element: <ApiFeedSolution /> },
    { path: "/CatalogSolution", element: <CatalogSolution /> },
  ]);
  return routes;
};

const AppWrapper = () => {
  return (
    <Router>
      <App />
    </Router>
  );
};

export default AppWrapper;
